[
  {
    "name": "join",
    "displayName": "Join",
    "inputType": "array",
    "outputType": "string",
    "example": {
      "input": {
        "parameters": {
          "separator": ","
        },
        "data": ["item one", "item two", "item three"]
      },
      "output": "item one,item two,item three"
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "separator": {
          "type": "string",
          "displayName": "Separator",
          "placeholder": "Enter a separator"
        }
      },
      "required": ["separator"],
      "errorMessages": {
        "separator": {
          "required": "You must enter a separator value"
        }
      }
    },
    "description": "Will combine all elements of the array into a single string"
  },
  {
    "name": "count-of-items",
    "displayName": "Count of Items",
    "inputType": "array",
    "outputType": "number",
    "example": {
      "input": {
        "data": ["item one", "item two", "item three"]
      },
      "output": 3
    },
    "description": "Counts the number of items in any given list"
  },
  {
    "name": "pick",
    "displayName": "Pick",
    "inputType": "array",
    "outputType": "array",
    "example": {
      "input": {
        "parameters": {
          "propertyKeys": ["user", "status"]
        },
        "data": [
          {
            "user": "user 1",
            "location": "honolulu",
            "status": "active"
          },
          {
            "user": "user 2",
            "location": "miami",
            "status": "inactive"
          }
        ]
      },
      "output": [
        {
          "user": "user 1",
          "status": "active"
        },
        {
          "user": "user 2",
          "status": "inactive"
        }
      ]
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "propertyKeys": {
          "type": "string",
          "displayName": "Property Keys",
          "placeholder": "Enter property keys (case sensitive)"
        }
      },
      "required": ["propertyKeys"],
      "errorMessages": {
        "propertyKey": {
          "required": "You must enter property key(s) to pick"
        }
      }
    },
    "description": "Will create an array of objects based on picked properties"
  },
  {
    "name": "first-item",
    "displayName": "First Item",
    "inputType": "array",
    "outputType": "any",
    "example": {
      "input": {
        "data": ["item one", "item two", "item three"]
      },
      "output": "item one"
    },
    "description": "Returns the first item in any given list"
  },
  {
    "name": "last-item",
    "displayName": "Last Item",
    "inputType": "array",
    "outputType": "any",
    "example": {
      "input": {
        "data": ["item one", "item two", "item three"]
      },
      "output": "item three"
    },
    "description": "Returns the last item in any given list"
  },
  {
    "name": "sentence-case",
    "displayName": "Convert to Sentence Case",
    "inputType": "string",
    "outputType": "string",
    "description": "Will convert text to sentence case.",
    "example": {
      "input": {
        "data": "hello world"
      },
      "output": "Hello World"
    }
  },
  {
    "name": "lower-case",
    "displayName": "Convert to Lower Case",
    "inputType": "string",
    "outputType": "string",
    "description": "Will convert text to lower case.",
    "example": {
      "input": {
        "data": "HELLO WORLD"
      },
      "output": "hello world"
    }
  },
  {
    "name": "upper-case",
    "displayName": "Convert to Upper Case",
    "inputType": "string",
    "outputType": "string",
    "description": "Will convert text to upper case.",
    "example": {
      "input": {
        "data": "hello world"
      },
      "output": "HELLO WORLD"
    }
  },
  {
    "name": "title-case",
    "displayName": "Convert to Title Case",
    "inputType": "string",
    "outputType": "string",
    "description": "Will convert text to title case.",
    "example": {
      "input": {
        "data": "hello world"
      },
      "output": "Hello World"
    }
  },
  {
    "name": "trim",
    "displayName": "Trim",
    "inputType": "string",
    "outputType": "string",
    "description": "Will trim whitespace from the beginning and end of a string.",
    "example": {
      "input": {
        "data": "  hello world  "
      },
      "output": "hello world"
    }
  },
  {
    "name": "trim-left",
    "displayName": "Trim Left",
    "inputType": "string",
    "outputType": "string",
    "description": "Will trim whitespace from the beginning of a string.",
    "example": {
      "input": {
        "data": "  hello world  "
      },
      "output": "hello world  "
    }
  },
  {
    "name": "concatenate",
    "displayName": "Concatenate",
    "inputType": "string",
    "outputType": "string",
    "description": "Will concatenate two strings.",
    "example": {
      "input": {
        "parameters": {
          "stringToAppend": "World"
        },
        "data": "Hello"
      },
      "output": "Hello World"
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "stringToAppend": {
          "type": "string",
          "displayName": "String to append",
          "placeholder": "Enter a string to append"
        }
      },
      "required": ["stringToAppend"],
      "errorMessages": {
        "stringToAppend": {
          "required": "You must enter a string to append"
        }
      }
    }
  },
  {
    "name": "set-if-empty",
    "displayName": "Set If Empty",
    "inputType": "string",
    "outputType": "string",
    "description": "Will set a string value if it is empty.",
    "example": {
      "input": {
        "parameters": {
          "defaultValue": "Hello World"
        },
        "data": ""
      },
      "output": "Hello World"
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "defaultValue": {
          "type": "string",
          "displayName": "Default Value",
          "placeholder": "Enter a default value"
        }
      },
      "required": ["defaultValue"],
      "errorMessages": {
        "defaultValue": {
          "required": "You must enter a default value"
        }
      }
    }
  },
  {
    "name": "set-decimal-places",
    "displayName": "Set Decimal Places",
    "inputType": "number",
    "outputType": "number",
    "description": "Will set decimal places.",
    "example": {
      "input": {
        "parameters": {
          "numberOfDecimals": 2
        },
        "data": 12.34567
      },
      "output": 12.35
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "numberOfDecimals": {
          "type": "integer",
          "displayName": "Number of Decimals",
          "placeholder": "Enter the number of decimals"
        }
      },
      "required": ["numberOfDecimals"],
      "errorMessages": {
        "numberOfDecimals": {
          "required": "You must enter a number of decimals value"
        }
      }
    }
  },
  {
    "name": "group-by",
    "displayName": "Group By",
    "inputType": "array",
    "outputType": "object",
    "example": {
      "input": {
        "parameters": {
          "propertyKey": "user"
        },
        "data": [
          {
            "user": "1",
            "caseNumber": "111"
          },
          {
            "user": "1",
            "caseNumber": "222"
          },
          {
            "user": "2",
            "caseNumber": "333"
          },
          {
            "user": "2",
            "caseNumber": "444"
          }
        ]
      },
      "output": {
        "1": [
          {
            "caseNumber": "111",
            "user": "1"
          },
          {
            "caseNumber": "222",
            "user": "1"
          }
        ],
        "2": [
          {
            "caseNumber": "333",
            "user": "2"
          },
          {
            "caseNumber": "444",
            "user": "2"
          }
        ]
      }
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "propertyKey": {
          "type": "string",
          "displayName": "Group by",
          "placeholder": "Enter a property key (case sensitive)"
        }
      },
      "required": ["propertyKey"],
      "errorMessages": {
        "propertyKey": {
          "required": "You must enter a property key to group the array"
        }
      }
    },
    "description": "Will group items in an array by property key"
  },
  {
    "name": "sort-by",
    "displayName": "Sort By",
    "inputType": "array",
    "outputType": "array",
    "example": {
      "input": {
        "parameters": {
          "sortBy": "age",
          "sortOrder": "Ascending"
        },
        "data": [
          {
            "user": "fred",
            "age": 40
          },
          {
            "user": "barney",
            "age": 36
          }
        ]
      },
      "output": [
        {
          "user": "barney",
          "age": 36
        },
        {
          "user": "fred",
          "age": 40
        }
      ]
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "propertyKey": {
          "type": "string",
          "displayName": "Sort by",
          "placeholder": "Enter a property key (case sensitive)"
        },
        "sortOrder": {
          "type": "string",
          "displayName": "Sort order",
          "defaultValue": "asc",
          "options": [
            {
              "text": "Ascending",
              "value": "asc"
            },
            {
              "text": "Descending",
              "value": "desc"
            }
          ]
        }
      },
      "required": ["propertyKey"],
      "errorMessages": {
        "propertyKey": {
          "required": "You must enter a property key to sort the array"
        }
      }
    },
    "description": "Will sort items in an array by property key."
  },
  {
    "name": "filter",
    "displayName": "Filter",
    "inputType": "array",
    "outputType": "array",
    "example": {
      "input": {
        "parameters": {
          "conditions": [
            {
              "leftComparator": "age",
              "operator": "eq",
              "rightComparator": "36"
            }
          ]
        },
        "data": [
          {
            "user": "barney",
            "age": 36,
            "active": true
          },
          {
            "user": "fred",
            "age": 40,
            "active": false
          }
        ]
      },
      "output": [
        {
          "user": "barney",
          "age": 36,
          "active": true
        }
      ]
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "conditions": {
          "type": "array",
          "displayName": "Filter conditions",
          "description": "Enter the conditions that an item must meet in order to be included in the filtered list.",
          "placeholder": "Property key (i.e User)",
          "items": {
            "type": "object",
            "properties": {
              "leftComparator": {
                "type": "string"
              },
              "operator": {
                "type": "string"
              },
              "rightComparator": {
                "type": "string"
              }
            },
            "required": ["leftComparator"]
          }
        }
      },
      "required": ["propertyKey", "comparator", "matchingValue"],
      "errorMessages": {
        "propertyKey": {
          "required": "You must enter a property key to filter by"
        },
        "comparator": {
          "required": "You must enter a comparator"
        },
        "matchingValue": {
          "required": "You must enter a value to be matched"
        }
      }
    },
    "description": "Will filter all elements of the array by property key"
  },
  {
    "name": "find",
    "displayName": "Find",
    "inputType": "array",
    "outputType": "object",
    "example": {
      "input": {
        "parameters": {
          "conditions": [
            {
              "leftComparator": "user",
              "operator": "eq",
              "rightComparator": "fred"
            }
          ]
        },
        "data": [
          {
            "user": "barney",
            "age": 36,
            "active": true
          },
          {
            "user": "fred",
            "age": 40,
            "active": false
          }
        ]
      },
      "output": [
        {
          "user": "fred",
          "age": 40,
          "active": false
        }
      ]
    },
    "parametersSchema": {
      "type": "object",
      "properties": {
        "conditions": {
          "type": "array",
          "displayName": "Find conditions",
          "description": "Enter the conditions that an item must meet in order to be returned.",
          "placeholder": "Property key (i.e User)",
          "items": {
            "type": "object",
            "properties": {
              "leftComparator": {
                "type": "string"
              },
              "operator": {
                "type": "string"
              },
              "rightComparator": {
                "type": "string"
              }
            },
            "required": ["leftComparator"]
          }
        }
      },
      "required": ["propertyKey", "comparator", "matchingValue"],
      "errorMessages": {
        "propertyKey": {
          "required": "You must enter a property key to filter by"
        },
        "comparator": {
          "required": "You must enter a comparator"
        },
        "matchingValue": {
          "required": "You must enter a value to be matched"
        }
      }
    },
    "description": "Will find the first element of an array that meets the specified conditions"
  }
]
